module.exports = __webpack_public_path__ + "img/icon_upload.d328d2c6.svg";